var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 30C23.9093 30 30.625 23.2843 30.625 15C30.625 6.71573 23.9093 0 15.625 0C7.34073 0 0.625 6.71573 0.625 15C0.625 23.2843 7.34073 30 15.625 30Z",
    fill: "#EFAE20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.391 21.5464C25.1707 21.6758 24.914 21.75 24.64 21.75H6.61C6.33599 21.75 6.07931 21.6758 5.85897 21.5464L11.875 15.5303L13.3598 17.0152C13.9336 17.589 14.6964 17.875 15.625 17.875C16.5536 17.875 17.3164 17.589 17.8902 17.0152L19.375 15.5303L25.391 21.5464ZM25.9214 21.016L19.9053 15L25.9214 8.98397C26.0508 9.20431 26.125 9.46099 26.125 9.735V20.265C26.125 20.539 26.0508 20.7957 25.9214 21.016ZM5.32864 21.016C5.19921 20.7957 5.125 20.539 5.125 20.265V9.735C5.125 9.46099 5.19921 9.20431 5.32864 8.98397L11.3447 15L5.32864 21.016ZM25.391 8.45364L17.3598 16.4848C16.9336 16.911 16.363 17.125 15.625 17.125C14.887 17.125 14.3164 16.911 13.8902 16.4848L5.85897 8.45364C6.07931 8.32421 6.33599 8.25 6.61 8.25H24.64C24.914 8.25 25.1707 8.32421 25.391 8.45364Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsg);
export default __webpack_public_path__ + "static/media/msg.3b25a6908b04961c406e6ced76989121.svg";
export { ForwardRef as ReactComponent };